import * as userCommonAPI from "../../common/api/user"
import * as uuid from "../../common/utils/uuid"
import * as taskBusinss from "./task"
import * as configs from "../configs"
export function getPrizeList({ sandbox, loginState, offerId, groupid }) {
  //缓存同一活动号下的奖池信息，用户切换弹框的时候不需要重复请求
  const historyPrizeList = sessionStorage.getItem(groupid)
  if (historyPrizeList) {
    return Promise.resolve(JSON.parse(historyPrizeList))
  } else {
    return userCommonAPI
      .luckDrawProc(
        {
          offerId: offerId,
          sandbox: sandbox
        },
        {
          ...loginState,
          zoneid: 1,
          accounttype: "qb",
          no_sig_check: 1,
          action: "query_productlist",
          card_id: groupid
        }
      )
      .then(res => {
        sessionStorage.setItem(groupid, JSON.stringify(res.luckdraw_info.luck_mpinfo.product))
        return res.luckdraw_info.luck_mpinfo.product
      })
  }
}

export function getLuckCoupon({ sandbox, loginState, offerId, groupid }) {
  return userCommonAPI
    .luckDrawProc(
      {
        offerId: offerId,
        sandbox: sandbox
      },
      {
        ...loginState,
        zoneid: 1,
        accounttype: "qb",
        no_sig_check: 1,
        action: "query_coupon",
        card_id: groupid
      }
    )
    .then(res => {
      return res.luckdraw_info.luck_mpinfo.coupon
    })
}

export function startDraw({ sandbox, loginState, offerId, game_platform_id, gameid, code_id, groupid }) {
  return userCommonAPI
    .luckDrawProc(
      {
        offerId: offerId,
        sandbox: sandbox
      },
      {
        no_sig_check: 1,
        billno: `${new Date()
          .toISOString()
          .substr(0, 10)
          .replace(/-/g, "")}-${uuid.generate(7).toLowerCase()}`,
        zoneid: 1,
        action: "luck_lottery",
        card_id: groupid,
        ...loginState,
        game_platform_id,
        gameid,
        code_id
      }
    )
    .then(res => {
      return res.luckdraw_info.luckydraw_result[0].luck_got_goods[0]
    })
}

export function getLuckAward({ sandbox, loginState, offerId, groupid, pagesize = 20, curpage = 1 }) {
  return userCommonAPI
    .luckDrawProc(
      {
        offerId: offerId,
        sandbox: sandbox
      },
      {
        ...loginState,
        zoneid: 1,
        no_sig_check: 1,
        action: "query_award",
        card_id: groupid,
        curpage,
        pagesize
      }
    )
    .then(res => {
      return res.luckdraw_info.luck_mpinfo.award
    })
}

/**
 *
 * @param rank 用户当前选中第几个档位宝箱 1到6的一个值 ,第7个宝箱也是6
 * @param total_score 用户积分比如31
 * @param present_rank 用户已经领取过的档位奖励 1,2,3,4,5
 * @param levels 活动一个循环是几 ，默认6档
 * @returns {[]}
 */
export function getAvailableOpenPresentRank({ rank, total_score, present_rank, levels = 6 }) {
  const result = []
  if (rank == 7) {
    rank = 6
  }
  const reveivedRank = present_rank.split(",")
  for (let i = rank; i <= total_score; i = i + levels) {
    if (!reveivedRank.includes(i.toString())) {
      result.push(i.toString())
    }
  }
  return result
}

export function getAllLuckCoupon({ sandbox, loginState, offerId, cardidList, sixCardId }) {
  return userCommonAPI
    .luckDrawProc(
      {
        offerId: offerId,
        sandbox: sandbox
      },
      {
        ...loginState,
        zoneid: 1,
        accounttype: "qb",
        no_sig_check: 1,
        action: "query_coupon_multi",
        card_id: cardidList
      }
    )
    .then(res => {
      const luckInfo = res.luckdraw_info.luck_mpinfo
      const sixCardQuerySuc = sixCardId.every(item => luckInfo[item]?.length > 0)
      if (sixCardQuerySuc) {
        return luckInfo
      } else {
        throw new Error("查无抽奖券")
      }
    })
}

export function checkAllLuckCoupon({ sandbox, loginState, offerId, cardidList }) {
  return userCommonAPI
    .luckDrawProc(
      {
        offerId: offerId,
        sandbox: sandbox
      },
      {
        ...loginState,
        zoneid: 1,
        accounttype: "qb",
        no_sig_check: 1,
        action: "query_coupon_multi",
        card_id: cardidList
      }
    )
    .then(res => {
      const luckInfo = res.luckdraw_info.luck_mpinfo
      return luckInfo
    })
}

export async function batchGetAllCoupon({ loginState, partitionInfo, offerId, sandbox, task_id, groupid, map }) {
  try {
    await taskBusinss.getAllTaskPresent({
      loginState,
      partitionInfo,
      offerId,
      sandbox,
      task_id,
      groupid
    })
    const queryAllCouponResult = await getAllLuckCoupon({
      sandbox,
      loginState,
      offerId,
      cardidList: configs.GAME_INFO.drawGroupid[map]
        .filter(item => item.rank <= 6)
        .map(item => item.groupid)
        .join(",")
    })
    console.log(queryAllCouponResult)
  } catch (res) {
    console.log(res)
  }
}
